import _ from 'underscore'

import utils from '@/utils/utils'
import { getFingerprint } from '../services/fingerprint-service'

export async function buildSignupPayload ({
  formValues,
  turnstileToken,
}) {
  let userMetadata = utils.getUserMetadata()
  userMetadata = _.map(userMetadata, (val, key) => ({ name: key, value: val }))
  userMetadata.push({ name: 'currentUrl', value: window.location.href })

  const fingerprintData = await getFingerprint()

  return {
    'cf-turnstile-token': turnstileToken,
    referalCode: formValues.referalCode || '',
    nick: formValues.nick,
    email: formValues.email,
    password: formValues.password,
    cpassword: formValues.cpassword,
    tos: formValues.acceptTerms ? '1' : false,
    oldenough: formValues.checkAge ? '1' : false,
    newsletter: formValues.newsletter ? '1' : false,
    users_metadata: userMetadata,
    source: 'web',
    fingerprint: fingerprintData.visitor_id,
    event_id: fingerprintData.event_id,
  }
}

export async function buildFacebookRegisterPayload ({
  formValues,
  fbData,
}) {
  let userMetadata = utils.getUserMetadata()
  userMetadata = _.map(userMetadata, (val, key) => ({ name: key, value: val }))
  userMetadata.push({ name: 'currentUrl', value: window.location.href })

  const fingerprintData = await getFingerprint()

  return {
    fingerprint: fingerprintData.visitor_id,
    event_id: fingerprintData.event_id,
    referalCode: formValues.referalCode || '',
    name: formValues.name,
    last_name: formValues.lastName,
    nick: formValues.nick,
    email: formValues.email,
    password: formValues.password,
    cpassword: formValues.cpassword,
    tos: formValues.acceptTerms ? '1' : false,
    oldenough: formValues.checkAge ? '1' : false,
    newsletter: formValues.checkGetNews ? '1' : false,
    provider_uid: fbData.userID,
    profile_picture: fbData.picture?.data?.url,
    users_metadata: userMetadata,
    source: 'web',
  }
}
